import { render, staticRenderFns } from "./EditProName.vue?vue&type=template&id=17d2a570&scoped=true"
import script from "./EditProName.vue?vue&type=script&lang=js"
export * from "./EditProName.vue?vue&type=script&lang=js"
import style0 from "./EditProName.vue?vue&type=style&index=0&id=17d2a570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d2a570",
  null
  
)

export default component.exports